module.exports = __webpack_public_path__ + "static/media/AlKhori_dealerhighlight_mobile_hero.c46f95e5.jpg";